import { render, staticRenderFns } from "./GreetingsEditor.vue?vue&type=template&id=d543b7b6&"
import script from "./GreetingsEditor.vue?vue&type=script&lang=js&"
export * from "./GreetingsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports